import type { Doc } from "building-types/doc";
import type { Foundation } from "building-types/foundations/foundationSystemTypes";
import type { FoundationSystemHandle } from "building-types/handles/docEntityHandleTypes";

export function docGetFoundationSystemFoundations(
  doc: Pick<Doc, "foundations">,
  { id: foundationSystemId }: FoundationSystemHandle,
): Foundation[] {
  return Object.values(doc.foundations)
    .filter((x) => x.parentId === foundationSystemId)
    .sort((a, b) => a.sortIndex - b.sortIndex);
}

export function docGetFoundationSystemFoundationIdsFromFoundationTable(
  foundations: Doc["foundations"],
  { id: foundationSystemId }: FoundationSystemHandle,
): string[] {
  return Object.keys(foundations)
    .filter((id) => foundations[id].parentId === foundationSystemId)
    .sort((a, b) => foundations[a].sortIndex - foundations[b].sortIndex);
}
